module.exports = __webpack_public_path__ + "static/media/mitratel.8d3b6a51.png";